import React from 'react';
import { getEnv } from '../../utils/environment';
import getLoginUrl from '../../utils/getLoginUrl';
import styles from './CheckoutForm.module.css';

export type AutoLoginError = {
  message: string;
  errorCode: string;
}
export type AutoLoginProps = {
  error: AutoLoginError;
  email?: string;
}

const createAutoLoginToast = (props: AutoLoginProps): React.ComponentType<any> => {
  const { email, error } = props;
  return (): JSX.Element => {
    const { message, errorCode } = error;
    const reactivateCtaUrl = `${getEnv().baseUrl}%2Freactivate-my-membership%2F%3Fcoupon_code%3Dgetstarted`;
    const loginLinkOnError = getLoginUrl(errorCode, email, reactivateCtaUrl);
    return (
      <>
        {loginLinkOnError.type === '' && message && <div className={styles.autologinText}>{message}</div>}
        {loginLinkOnError.type === 'active' && (
        <span className={styles.autologinText}>
          Oops! It looks like you&apos;re already member of FabFitFun! Please
          { ' ' }
          <a href={loginLinkOnError.url}>log in</a>
          { ' ' }
          or use a different email address to create another account.
        </span>
        )}
        { loginLinkOnError.type === 'inactive' && (
        <span className={styles.autologinText}>
          Wait! It looks like you&apos;re already a member of FabFitFun.
          { ' ' }
          <a href={loginLinkOnError.url}>Request a login link</a>
          { ' ' }
          to reactivate your membership.
        </span>
        )}
      </>
    );
  };
};

export {
  createAutoLoginToast,
};
